import React, { useCallback } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import HomeBarButton from '../../../../../../modules/dashboard/components/HomeBarButton';

import OfficeHoursModal from '../OfficeHoursModal';

import { ReactComponent as OfficeHoursIcon } from '../../../../../../public/images/ek/office-hours.svg';
import { useMytaverseEvent } from '../../../../../../modules/dashboard/providers';
import { AnalyticsType } from '../../../../../../interfaces/analytics';
import { useEventScheduler } from '../context/context';

const OfficeHoursButton = ({ t: translate }: WithTranslation) => {
  const { open, setOpen, toggleOpen } = useEventScheduler();

  const { currentEvent, trackEventAnalytics } = useMytaverseEvent();

  const handleOpenModal = useCallback(async () => {
    if (!open) {
      trackEventAnalytics(AnalyticsType.OfficeHoursModalUpcomingOpen);
    }
    toggleOpen();
  }, [trackEventAnalytics, toggleOpen, open]);

  if (
    !currentEvent?.inviteSlotsTags ||
    currentEvent.inviteSlotsTags.length === 0
  ) {
    return null;
  }

  return (
    <>
      <HomeBarButton
        label={translate('ek.officeHours.tooltip')}
        icon={<OfficeHoursIcon />}
        handleClick={handleOpenModal}
      />

      <OfficeHoursModal open={open} handleClose={() => setOpen(false)} />
    </>
  );
};

export default withTranslation('common')(OfficeHoursButton);
